'use client';

import '@findy/kuja/dist/css/index.css';
import '@findy/kuja/dist/css/index-v2.css';

import { Global } from '@emotion/react';

import { normalizeCss } from './normalize-css';
import { printStyles } from './print-styles';

// エディターでCSSのSyntax highlightを有効化する
const css = String.raw;

const baseStyle = css`
  /* stylelint-disable no-duplicate-selectors */

  /* Document */

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    font-family: 'Noto Sans JP', system-ui;
    font-size: 10px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    scroll-behavior: smooth;
  }

  /* normalizeCssの上書き */
  pre,
  code,
  kbd,
  samp {
    font-family: 'Noto Sans JP', system-ui;
  }

  /* Body */

  body {
    font-size: 14px;
    line-height: 1.42857143;
    color: var(--fds-color-text-primary);
    background-color: #fff;
  }

  /* Link */

  a {
    color: var(--fds-color-action-text-primary-default);
    text-decoration: none;
    background-color: transparent;
  }

  a:focus {
    color: #23527c;
    text-decoration: underline;
    outline: 5px auto -webkit-focus-ring-color;
  }

  a:hover {
    color: var(--fds-color-action-text-primary-default);
    text-decoration: underline;
    opacity: 0.7;
  }

  /* Image */

  img {
    vertical-align: middle;
  }

  /* Grouping content */

  hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: var(--fds-border-width-s) solid #eee;
  }

  /* Typography */

  h1,
  h2,
  h3,
  h4 {
    line-height: 1.1;
    color: inherit;
  }

  h1 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 36px;
  }

  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 30px;
  }

  h3 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 24px;
  }

  h4 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 18px;
  }

  p {
    margin: 0 0 10px;
  }
  small {
    font-size: 85%;
  }

  /* Lists */

  ol,
  ul {
    padding: 0;
    margin: 0 0 10px 0;
    list-style: none;
  }

  ul ul,
  ol ul,
  ul ol,
  ol ol {
    margin-bottom: 0;
  }

  dl {
    margin-top: 0;
    margin-bottom: 20px;
  }

  dt,
  dd {
    line-height: 1.42857143;
  }

  dt {
    font-weight: bold;
  }

  dd {
    margin-left: 0;
  }

  /* Forms */

  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }

  label {
    display: inline-block;
    max-width: 100%;
    font-weight: bold;
  }

  button,
  [role='button'] {
    cursor: pointer;
  }

  button[disabled],
  html input[disabled] {
    cursor: default;
  }

  input[type='radio'],
  input[type='checkbox'] {
    margin: 4px 0 0;
    line-height: normal;
  }

  input[type='file'] {
    display: block;
  }

  input[type='range'] {
    display: block;
    width: 100%;
  }

  select,
  textarea {
    font-size: inherit;
    line-height: inherit;
  }

  select[multiple],
  select[size] {
    height: auto;
  }

  textarea {
    min-height: 220px;
  }

  input[type='checkbox'],
  input[type='radio'] {
    color: #3d4145;
  }

  input[type='checkbox'] {
    display: inline;
  }

  input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus,
  textarea:focus {
    outline: 5px auto var(--fds-checkbox-color-border-focus);
    outline-offset: -2px;
  }

  input[type='radio'][disabled],
  input[type='checkbox'][disabled],
  input[type='radio'].disabled,
  input[type='checkbox'].disabled,
  fieldset[disabled] input[type='radio'],
  fieldset[disabled] input[type='checkbox'] {
    cursor: not-allowed;
  }

  label {
    display: block;
  }

  fieldset[disabled] .radio label,
  fieldset[disabled] .checkbox label {
    cursor: not-allowed;
  }

  select {
    height: 44px;
    padding: 10px 16px;
    border: var(--fds-border-width-s) solid #efefef;
    border-radius: var(--fds-border-radius-s);
  }

  label span {
    color: #8b9798;
  }

  /* Table */

  table {
    border-spacing: 0;
    border-collapse: collapse;
  }

  td,
  th {
    padding: 0;
  }
`;

/**
 * 基礎となるスタイルをGlobalとして提供します。
 * Yuffie内のUIは、このスタイルの使用を前提とします。
 * 基本的には_app.tsxを介してほとんどのページに適用されています。
 */
export const GlobalStyle = () => (
  <Global styles={[normalizeCss, printStyles, baseStyle]} />
);
